<template>
    <div class="table-responsive mt-3" style="overflow: auto; padding-bottom: 30px; max-height: 70vh">
        <table class="table" style="text-align: center">
            <thead>
            <tr style="border: 1px solid #ebedf3">
                <th class="header-table w-60px" scope="col">STT</th>
                <th class="header-table min-w-90px" scope="col">Mã log</th>
                <th class="header-table min-w-100px" scope="col">Mã học viên</th>
                <th class="header-table min-w-140px" scope="col">Trạng thái thanh toán cho IDP</th>
                <th class="header-table min-w-220px" scope="col">Kết quả kiểm tra</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item of responseError" :key="item.rowIndex" style="border: 1px solid #ebedf3; border-top: 0">
                <td>{{ item.rowIndex }}</td>
                <td style="text-align: start">{{ item.logCode }}</td>
                <td style="text-align: start">{{ item.studentCode }}</td>
                <td style="text-align: start">{{ item.status }}</td>
                <td style="text-align: start">
                    <div
                        v-if="item.errors && item.errors.length"
                        style="text-align: start; display: flex; flex-direction: column; color: #d52323; font-weight: 500"
                    >
                        <span>Lỗi:</span>
                        <span v-for="(error, index) in item.errors" :key="index + error" style="word-break: break-word">
                - {{ error }}
              </span>
                    </div>
                    <span v-else style="color: #0c9200; font-weight: 500">Đạt</span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: "TableErrorImportIdpExamFee",
    props: {
        responseError: {
            type: Array,
            default: () => [],
        },
    },
};
</script>

<style scoped>
.header-table {
    background: #f8f8f8;
    text-align: start;
    word-break: break-word;
}
</style>
